export default function appBar({ variables }) {
    return {
        MuiAppBar: {
            defaultProps: {
                elevation: 0,
                color: "default",
            },
            styleOverrides: {
                root: {
                    backgroundColor: variables.surface,
                    color: variables.text_primary,
                    boxShadow: "none",
                    borderBottom: `1px solid ${variables.border_subtle}`,
                    backgroundImage: "none",
                },
            },
        },
    };
}
//# sourceMappingURL=appBar.js.map